import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss']
})
export class CookieConsentComponent implements OnInit {
  showBanner = false;
  showPreferences = false;

  prefs = {
    necessary: true,
    analytics: false,
    marketing: false
  };

  ngOnInit(): void {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      this.showBanner = true;
    }
  }

  accept() {
    this.prefs.analytics = true;
    this.prefs.marketing = true;
    this.savePreferences();
  }

  refuse() {
    this.prefs.analytics = false;
    this.prefs.marketing = false;
    this.savePreferences();
  }

  togglePreferences() {
    this.showPreferences = !this.showPreferences;
  }

  savePreferences() {
    localStorage.setItem('cookieConsent', JSON.stringify(this.prefs));
    this.showBanner = false;
  }

  close() {
    this.showBanner = false;
  }
}
